<app-basic-form [form]="form" [keys]="keys"></app-basic-form>